require('./mortgageRequestError.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ utilities
const { formatText } = require('core/i18n').i18n;
// @ commonst
const WizardError = require('components/commons/wizardError/wizardError');
// @ constants
const { COMMONS: { MORTGAGE_ESTATES_HAS_NS_PHONE } } = require('constants/mortgageRequestHolderData');

class MortgageRequestError extends React.Component {
    render() {
        const { phoneNumber } = this.props;
        const linkToMovements = '/myprofile/loans-mortgages';

        let errorMessage = formatText('mortgageRequestError-titleHeader');
        let errorMessageInstruction = formatText('mortgageRequestError-message1');
        let errorPhoneMessage = formatText('mortgageRequestError-message2', [phoneNumber]);
        let goBackButtonLabel = formatText('mortgageRequestError-returnLoans');

        if (this.props.query.get('coHolderError')) {
            errorMessage = formatText('mortgageRequestError-titleHeader1');
            errorMessageInstruction = formatText('mortgageRequestError-message3', [phoneNumber]);
            errorPhoneMessage = '';
            goBackButtonLabel = formatText('mortgageRequestError-returnLinkCoHolderError');
        }

        if (this.props.query.get('other')) {
            goBackButtonLabel = formatText('mortgageRequestError-returnLinkCoHolderError');
        }

        const mainButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        }

        return (
            <WizardError
                errorMessage={errorMessage}
                mainButton={mainButton}
            >
                <div className="mortgage-request-error">
                    <span className="mortgage-request-error__text">{errorMessageInstruction}</span>
                    <span className="mortgage-request-error__text">{errorPhoneMessage}</span>
                </div>
            </WizardError>
        );
    }
}

MortgageRequestError.propTypes = {
    phoneNumber: PropTypes.string,
    query: PropTypes.object
}

MortgageRequestError.defaultProps = {
    phoneNumber: MORTGAGE_ESTATES_HAS_NS_PHONE,
    query: new URLSearchParams('')
}

module.exports = MortgageRequestError;
